import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategories } from '@/api/categories';

export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { getState }) => {
    const response = await getCategories(1, 20);
    
    let newCategories = [];
    if (response.data && response.data.data) {
      newCategories = response.data.data;
    } else if (response.data) {
      newCategories = response.data;
    } else {
      newCategories = response;
    }
    
    return newCategories;
  },
  {
    condition: (_, { getState }) => {
      const { categories } = getState();
      if (categories.items.length > 0 || categories.loading) {
        return false;
      }
    }
  }
);

const categorySlice = createSlice({
  name: 'categories',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default categorySlice.reducer;
